module.exports = __webpack_public_path__ + "static/media/logo-rio.ebebc7df.svg";